import { useEffect, useState } from "react";
import { NAV_LINKS, isSectionShown } from "../data/content";

export function Nav() {
  const [open, setOpen] = useState(false);

  // Close the collapsed menu if the viewport grows back past the breakpoint,
  // otherwise it stays "open" invisibly and traps the next toggle.
  useEffect(() => {
    const mql = window.matchMedia("(min-width: 901px)");
    const onChange = () => mql.matches && setOpen(false);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return (
    <nav className="nav">
      <div className="nav__row">
        <a className="nav__logo" href="#home" aria-label="Aimee and Benjamin — back to top">
          <span className="monogram" role="img" aria-label="Aimee and Benjamin monogram" />
        </a>

        <div
          id="nav-links"
          className={`nav__links${open ? " nav__links--open" : ""}`}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              className="nav__link"
              href={link.href}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          className="nav__toggle"
          aria-expanded={open}
          aria-controls="nav-links"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Close" : "Menu"}
        </button>

        {isSectionShown("rsvp") && (
          <a className="btn btn--paper" href="#rsvp" onClick={() => setOpen(false)}>
            RSVP
          </a>
        )}
      </div>
    </nav>
  );
}
